import { render, staticRenderFns } from "./MemberTypeSelection.vue?vue&type=template&id=3592e374&"
import script from "./MemberTypeSelectionVue.ts?vue&type=script&lang=ts&"
export * from "./MemberTypeSelectionVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports